import React from "react";
import termsAndConditionsFetchData from "@/data/domain/terms-and-conditions.json";
import { v4 as uuidv4 } from "uuid";
import { PAGE_TITLE } from "@/common/constants/constants";

import styles from "../styles/TermsAndConditionsPage.module.scss";

const TermsAndConditionsComponent = () => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{PAGE_TITLE.TERMS_AND_CONDITIONS}</h1>
      <div className={styles.content}>
        {termsAndConditionsFetchData.map((item) => {
          return (
            <div key={uuidv4()}>
              <div className={styles.paragraphTitle}> {item.title}</div>
              {item.paragraph}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TermsAndConditionsComponent;
